// Case study catalog. Mirrors https://himanshutanty.com/portfolio/<slug>/ faithfully.
//
// Per-study content lives under `/app/frontend/src/data/studies/<slug>.js`.
// This file is a thin aggregator so imports across the app stay stable:
//     import { caseStudies, author } from '@/data/caseStudies';
//
// Block schema (`type` field on each study):
//   - `type: 'rich'`      → block-based body rendered by `RichBlocks.jsx`
//   - `type: 'gallery'`   → images + optional prototype link
//   - `type: 'external'`  → cover + one big "View project on Behance" CTA
//   - `type: 'protected'` → the source case study is behind a password; link to source
//   - `type: 'note'`      → short real note + images (Individual Development Plan)
//
// The `next` field cycles through the projects in the source's own order.

import { homepageRedesign } from './studies/homepage-redesign';
import { myCommunication } from './studies/my-communication';
import { symptomTracking } from './studies/symptom-tracking';
import { travelApp } from './studies/travel-app';
import { graphicDesigns } from './studies/graphic-designs';
import { portalForSiteContractors } from './studies/portal-for-site-contractors';
import { webTemplate } from './studies/web-template';
import { cloudhubEnterpriseRedesign } from './studies/cloudhub-enterprise-redesign';
import { beyondTheDashboard } from './studies/beyond-the-dashboard';

export const caseStudies = {
    'beyond-the-dashboard': beyondTheDashboard,
    'homepage-redesign': homepageRedesign,
    'my-communication': myCommunication,
    'symptom-tracking': symptomTracking,
    'travel-app': travelApp,
    'graphic-designs': graphicDesigns,
    'portal-for-site-contractors': portalForSiteContractors,
    'web-template': webTemplate,
    'cloudhub-enterprise-redesign': cloudhubEnterpriseRedesign,
};

export const author = {
    name: 'Himanshu Kumar Tanty',
    linkedin: 'https://www.linkedin.com/in/anshuu/',
    instagram: 'https://www.instagram.com/anshuhim/',
};
